import { MarketplaceQueryOptions } from 'vrlcm-gui-types';

export namespace MarketplaceApiUri {
  const BASE_URL = `/lcm/marketplace/api`;

  const BASE_URL_V2 = '/lcm/marketplace/api/v2';

  const CLOUD_MP_URL = `https://api.marketplace.cloud.vmware.com`;

  export const GET_LCM_MARKETPLACE_ITEMS_URL = (
    opts: MarketplaceQueryOptions
  ) => {
    const urlParams = new URLSearchParams();
    urlParams.set('page', (opts.currentPage - 1).toString());
    urlParams.set('size', opts.pageSize.toString());
    if (opts.search && opts.search.length > 0) {
      urlParams.set('search', opts.search);
    }
    urlParams.set('isDownloaded', opts.isDownloaded ? 'true' : 'false');

    return `${BASE_URL}/apps/filter?${urlParams.toString()}`;
  };

  export const GET_CLOUD_MARKETPLACE_CONTENTS_URL = `${BASE_URL}/mp-contents/listing`;

  export const LCM_MARKETPLACE_ITEM_BY_SLUG_URL = (
    slug: string,
    version: string
  ) => `${BASE_URL_V2}/apps/${slug}/${version}`;

  export const MARKETPLACE_ITEM_BY_SLUG_URL = (slug: string) =>
    `${BASE_URL}/mp-contents/${slug}`;

  export const MARKETPLACE_ITEM_DELETE = `${BASE_URL_V2}/appDelete`;

  export const MARKETPLACE_VERSION_DETAILS = `${CLOUD_MP_URL}/products/getVersionSpecificProductDetails`;

  export const GET_MARKETPLACE_FILTER_CATAGORIES_URL = `${BASE_URL}/filterCategories`;

  export const TRIGGER_MARKETPLACE_SYNC_URL = `${BASE_URL}/apps/sync`;

  export const TRIGGER_MARKETPLACE_APP_DOWNLOAD_URL = `${BASE_URL}/appDownload`;

  export const TRIGGER_MARKETPLACE_APP_INSTALL_URL = `${BASE_URL}/appInstall`;

  export const GET_MARKETPLACE_VRA_TENANT_LICENSE_INFO_URL = `${BASE_URL}/vraTenantLicenseInfo`;

  export const GET_MARKETPLACE_EULA_FOR_SLUG_URL = (slug: string) =>
    `${BASE_URL}/eula/${slug}`;

  export const TRIGGER_MARKETPLACE_EULA = (contentId: string) =>
    `${BASE_URL}/eula/${contentId}`;
}
